import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'fgb-lotto-detail-page',
  templateUrl: './lotto-detail-page.component.html',
  styleUrls: ['./lotto-detail-page.component.scss'],
})
export class LottoDetailPageComponent implements OnInit {
  id: number;
  backLink: string = '/rewards';
  constructor(
    private route: ActivatedRoute,
    private location: Location
  ) {}
  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
  }
  goBack() {
    this.location.back();
  }
}
